export default {
    FETCH_DC_STATUSES: "FETCH_DC_STATUSES",
    FETCH_DC_STATUSES_SUCCESS: "FETCH_DC_STATUSES_SUCCESS",
    FETCH_DC_STATUSES_FAILURE: "FETCH_DC_STATUSES_FAILURE"
} as any;
